export default{
    getUrlKey:function(name){
     return decodeURIComponent((new RegExp('[?|&]'+name+'='+'([^&;]+?)(&|#|;|$)').exec(location.href)||[,""])[1].replace(/\+/g,'%20'))||null;
    },
    generateName:function(){
        let time = new Date();
        let y = time.getFullYear();
        let m = time.getMonth() + 1;
        let d = time.getDate();
        let h = time.getHours();
        let mm = time.getMinutes();
        let s = time.getSeconds();
        let ss = time.getTime();
        return "" + y + add0(m) + add0(d) + add0(h) + add0(mm) + add0(s) + ss;
    }
}
   
   
          